import { todayUpdates } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function TodayUpdates() {
  return (
    <section id="today" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="今日更新 · 每日整理"
            title="今天新上架的电影资源"
            desc="按上架时间顺序排列，清晰标注类型、地区与画质标签，方便你第一时间看到最新电影资源。"
          />
          <div className="flex items-center gap-3 shrink-0">
            <span className="inline-flex items-center gap-2 px-3 py-2 rounded-md bg-accent-100 text-accent-900 text-sm">
              <i className="ri-refresh-line"></i>
              今日共更新 {todayUpdates.length} 部
            </span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
          {todayUpdates.map((m) => (
            <a
              key={m.id}
              href="#hot"
              className="group flex items-center gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-16 h-24 md:w-[72px] md:h-[104px] rounded-md overflow-hidden shrink-0 bg-background-200">
                <img
                  src={m.poster}
                  alt={`${m.title} 电影封面，${m.genre}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 truncate">
                    {m.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-[11px]">
                    {m.quality}
                  </span>
                </div>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 flex flex-wrap items-center gap-x-3 gap-y-1">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-price-tag-3-line"></i>
                    {m.genre}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-map-pin-line"></i>
                    {m.region}
                  </span>
                </p>
                <div className="mt-3 flex items-center justify-between gap-3">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-time-line"></i>
                    今日 {m.time} 上架
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    {m.episode}
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}